package com.kanati.admin.features.settings

import androidx.compose.runtime.*
import com.kanati.admin.api.AdminApiClient
import com.kanati.admin.components.*
import com.kanati.admin.state.*
import com.kanati.shared.consumer.ConsumerAppRuntimeConfigResponse
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

fun ConsumerAppRuntimeConfigResponse.requireScope(districtId: String, schoolId: String): ConsumerAppRuntimeConfigResponse {
    require(this.districtId == districtId && this.schoolId == schoolId) { "Consumer configuration scope does not match the selected school." }
    return this
}

@Composable
fun ConsumerConfigPanel(apiClient: AdminApiClient, school: SelectedSchoolContext, theme: MaterialThemePalette) {
    val state = remember(school.id) { ReadState<ConsumerAppRuntimeConfigResponse>() }
    val scope = rememberCoroutineScope()
    suspend fun refresh() = state.refresh("Consumer configuration unknown. The public school lookup failed or returned a different school/district. Confirm the school is active and the backend is reachable, then retry.") {
        apiClient.getConsumerRuntimeConfig(school.id).requireScope(school.districtId, school.id)
    }
    LaunchedEffect(school.id) { refresh() }
    SectionCard("Consumer school configuration", theme, description = school.name, headerActions = {
        ActionButton(if (state.loading) "Checking..." else "Check Consumer config", { scope.launch { refresh() } }, theme, isDisabled = state.loading, isPrimary = false)
    }) {
        P { Text("School ID: ${school.id} · District ID: ${school.districtId} · ${if (school.active) "Active" else "Inactive"}") }
        P { Text("Admin API base: ${apiClient.baseUrl}. Consumer Android must use the corresponding public backend and this school ID. A local /api proxy is not a device URL.") }
        P { Text("Public lookup: /consumer/schools/${school.id}/runtime-config") }
        if (state.loading) StatusBanner("Loading the configuration Consumer receives...", theme)
        state.error?.let { StatusBanner(it, theme, BannerTone.Error) }
        state.value?.let { config ->
            StatusBanner("School lookup succeeded for the selected district and school.", theme, BannerTone.Success)
            P { Text("Theme: ${if (config.settings?.nativeUiThemeJson.isNullOrBlank()) "absent · bundled defaults allowed" else "district override stored"}") }
            P { Text("Pages: ${if (config.settings?.appDocumentJson.isNullOrBlank()) "absent · bundled defaults allowed" else "district app document stored"}") }
        }
        P { Text("Runtime settings inherit from the district. This check verifies the backend lookup, not the Android build, page rendering, login, or checkout. Review payment configuration above and verify the installed app before opening gates.") }
    }
}
